import { SubscriptionModel } from '../interfaces';

const MaxNumberLength = 30;

export function suggestNumber(name: string, subscriptions: SubscriptionModel[]): string {
  const words = fold(name)
    .toUpperCase()
    .replace(/[^A-Z0-9]+/g, ' ')
    .trim()
    .split(' ')
    .filter(Boolean);
  if (words.length === 0) return '';

  const base = (words.length > 1 ? words.map((w) => w[0]).join('') : words[0].slice(0, 3)).slice(0, MaxNumberLength);

  const taken = new Set(subscriptions.map((x) => x.number?.toUpperCase()).filter(Boolean));
  if (!taken.has(base)) return base;
  for (let i = 2; ; i++) {
    const candidate = base.slice(0, MaxNumberLength - String(i).length) + i;
    if (!taken.has(candidate)) return candidate;
  }
}

/** Maconomy item numbers are plain ASCII. */
function fold(text: string): string {
  return text
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/æ/g, 'ae')
    .replace(/Æ/g, 'AE')
    .replace(/[øØ]/g, (c) => (c === 'ø' ? 'o' : 'O'));
}
